export default __webpack_public_path__ + "static/media/mheaderCita-min.2e8bb224.jpg";